import React from 'react';
import styles from '../css/modules/Breadcrumbs.module.css';

/**
 * Widoczne okruszki. Ten sam zestaw pozycji przekazujemy do breadcrumbSchema(),
 * bo Google wymaga zgodnosci sciezki widocznej i tej w danych strukturalnych.
 */
export default function Breadcrumbs({ items }) {
  return (
    <nav className={styles.crumbs} aria-label="Okruszki">
      <ol>
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={it.path}>
              {last ? (
                <span aria-current="page">{it.name}</span>
              ) : (
                <>
                  <a href={it.path}>{it.name}</a>
                  <span className={styles.sep} aria-hidden="true">
                    /
                  </span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
